import React, { Component } from 'react';

export default class EventImage extends Component {
	render() {
		return (
			<div>
				<svg
					id="Event"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 15.83 25.41"
					height="80px"
				>
					<title>Event Single</title>
					<path
						id="EarL"
						className="cls-2"
						d="M135.79,141.56a13.13,13.13,0,0,1,1-2.37.59.59,0,0,1-.19-.37c-.46-.31-1-.44-1.17.4C135.18,140.37,135.36,141.22,135.79,141.56Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="EarR"
						className="cls-2"
						d="M146.4,139.2a13.13,13.13,0,0,1,1,2.37c.43-.33.62-1.19.36-2.34-.19-.84-.71-.72-1.17-.4A.59.59,0,0,1,146.4,139.2Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Nose"
						className="cls-2"
						d="M141.54,143.07h.11a4.34,4.34,0,0,1,.85-.15.7.7,0,0,0,.13-.57,1,1,0,0,0-.34-.57,1.07,1.07,0,0,0-1.38,0,1,1,0,0,0-.34.54.71.71,0,0,0,.12.6A4.34,4.34,0,0,1,141.54,143.07Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Face"
						className="cls-2"
						d="M145.59,139.39c-1.24.12-2.59.19-4,.19a40.22,40.22,0,0,1-4.07-.21,5.44,5.44,0,0,0-.55,4.27.19.19,0,0,1,.19,0,1.87,1.87,0,0,0,1.87-.26,2.3,2.3,0,0,1,1.67-.43.71.71,0,0,1-.12-.6,1,1,0,0,1,.34-.54,1.07,1.07,0,0,1,1.38,0,1,1,0,0,1,.34.57.7.7,0,0,1-.13.57,2.3,2.3,0,0,1,1.67.44,1.87,1.87,0,0,0,1.87.27.19.19,0,0,1,.11,0A5.47,5.47,0,0,0,145.59,139.39Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Moustache"
						className="cls-3"
						d="M146.29,143.85a.2.2,0,0,0-.25-.23,1.87,1.87,0,0,1-1.87-.27,2.92,2.92,0,0,0-2.51-.28h-.11a2.92,2.92,0,0,0-2.51.28,1.87,1.87,0,0,1-1.87.26.2.2,0,0,0-.25.23c.19.76,1,2.36,4.64,1.55h.09C145.27,146.21,146.1,144.61,146.29,143.85Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Beard"
						className="cls-3"
						d="M146.4,139.2a.57.57,0,0,1-.31.14l-.5,0a5.47,5.47,0,0,1,.55,4.23.2.2,0,0,1,.14.24c-.18.71-.92,2.17-4,1.66a.7.7,0,0,1-1.33,0c-3.11.5-3.85-1-4-1.67a.19.19,0,0,1,.07-.2,5.44,5.44,0,0,1,.55-4.27l-.42,0a.57.57,0,0,1-.31-.14c-1.26,2.31-3.9,8.74,4.31,10.88a1.91,1.91,0,0,0,1,0C150.29,147.95,147.66,141.51,146.4,139.2Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Hat"
						className="cls-4"
						d="M136.63,138.54a.59.59,0,0,0,.48.79,41.29,41.29,0,0,0,9,0,.59.59,0,0,0,.48-.79L142,126.14a.39.39,0,0,0-.73,0Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Mouth"
						className="cls-1"
						d="M141.64,145.39h-.09l-.62.12a.7.7,0,0,0,1.33,0Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="EyeL"
						className="cls-1"
						d="M138.63,141.47a.64.64,0,0,1,1.29,0"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="EyeR"
						className="cls-1"
						d="M143.28,141.48a.64.64,0,0,1,1.29,0"
						transform="translate(-133.68 -125.52)"
					/>
					{/*<path
						id="ShoeL"
						class="cls-4"
						d="M138.9,155.34c-1.48,0-2.69.79-2.69,1.77a1.22,1.22,0,0,0,.08.44h5.2a1.22,1.22,0,0,0,.08-.44C141.58,156.14,140.38,155.34,138.9,155.34Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="ShoeR"
						class="cls-4"
						d="M144.27,155.35c-1.48,0-2.69.79-2.69,1.77a1.22,1.22,0,0,0,.08.44h5.2a1.22,1.22,0,0,0,.08-.44C147,156.15,145.75,155.35,144.27,155.35Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="LegL"
						class="cls-4"
						d="M138.9,155.34a2.6,2.6,0,0,1,2.64,1.48c0-.54,0-2.07,0-2.77h-5.22a9.16,9.16,0,0,0,.22,2.19A3.1,3.1,0,0,1,138.9,155.34Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="LegR"
						class="cls-4"
						d="M144.27,155.35a3.1,3.1,0,0,1,2.34.91,9.15,9.15,0,0,0,.22-2.19h-5.22c0,.7,0,2.23,0,2.77A2.6,2.6,0,0,1,144.27,155.35Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="Hat"
						class="cls-4"
						d="M136.63,138.54a.59.59,0,0,0,.48.79,41.29,41.29,0,0,0,9,0,.59.59,0,0,0,.48-.79L142,126.14a.39.39,0,0,0-.73,0Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="BeltLeft"
						class="cls-4"
						d="M140.5,152.34a.43.43,0,0,1,.42-.48h0s0,0,0-.06a.62.62,0,0,1,.05-.24h-5.26a1.44,1.44,0,0,0,0,.91h4.82A.36.36,0,0,1,140.5,152.34Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="BeltRight"
						class="cls-4"
						d="M147.45,151.56h-5.32l0,.07a.68.68,0,0,1,.52.66h0a.37.37,0,0,1-.06.18h4.82A1.44,1.44,0,0,0,147.45,151.56Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="ArmR"
						class="cls-5"
						d="M147.75,145a5.19,5.19,0,0,1-.5,1.6,8.32,8.32,0,0,1,.53,3.12,12.17,12.17,0,0,1-.06,1.24,2.26,2.26,0,0,0-.27,1.54h-.16l0,.09h.47a1.19,1.19,0,0,0,1.18-.94,9.42,9.42,0,0,0,.17-1.77A9.08,9.08,0,0,0,147.75,145Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="ArmL"
						class="cls-5"
						d="M135.73,152.46a2.3,2.3,0,0,0-.28-1.54,12.17,12.17,0,0,1-.06-1.24,21.21,21.21,0,0,1,.42-3.39,5.25,5.25,0,0,1-.37-1.33h0a9.08,9.08,0,0,0-1.4,4.87,9.42,9.42,0,0,0,.17,1.77,1.19,1.19,0,0,0,1.18.95h.46l0-.09Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="ArmDecR"
						class="cls-5"
						d="M147.77,150.31q0,.32,0,.62a1.38,1.38,0,0,1-.06.26c.49-.09,1-.18,1.41-.28,0-.21,0-.72.05-.93C148.7,150.1,148.25,150.21,147.77,150.31Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="ArmDecL"
						class="cls-5"
						d="M135.45,150.93c0-.15,0-.31,0-.47-.47-.08-.93-.18-1.35-.28,0,.2,0,.7.06.89.46.09.94.17,1.44.25A1.39,1.39,0,0,1,135.45,150.93Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="TorsoBottom"
						class="cls-5"
						d="M147.51,153.21l-.23-.73h-4.66a.39.39,0,0,1-.34.2h-1.39a.39.39,0,0,1-.34-.2h-4.67l-.23.73a.66.66,0,0,0,.63.86h10.6A.66.66,0,0,0,147.51,153.21Z"
						transform="translate(-133.68 -125.52)"
					/>
					<path
						id="TorsoTop"
						class="cls-5"
						d="M147.25,146.57c-.73,1.46-2.28,2.75-5.18,3.5a1.91,1.91,0,0,1-1,0c-3.08-.8-4.63-2.21-5.3-3.77a21.21,21.21,0,0,0-.42,3.39,12.17,12.17,0,0,0,.06,1.24,1.44,1.44,0,0,0,.27.69l0-.06H141a.61.61,0,0,1,1.13,0h5.32v0a1.44,1.44,0,0,0,.26-.67,12.17,12.17,0,0,0,.06-1.24A8.32,8.32,0,0,0,147.25,146.57Z"
						transform="translate(-133.68 -125.52)"
					/>
					*/}
				</svg>
			</div>
		);
	}
}
